import { ref } from 'vue';
import api from '../api';
import { SearchUserOutput, SearchUsersRequest, SearchUsersResponse } from '@ilteducation/customer-mgmt-types';

export const useSearchUsers = () => {
  const users = ref<SearchUsersResponse | null>();
  const loading = ref<boolean>(false);

  const searchUsers = async (request: SearchUsersRequest) => {
    loading.value = true;
    const response = await api.user
      .search(request)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Failed to search users', error);
        return { data: [], meta: { totalItems: 0 } };
      });

    users.value = response;
    loading.value = false;

    return users.value;
  };

  const fetchAllGroupMemebers = async (groupId: string): Promise<SearchUserOutput[]> => {
    const response = await api.group.users(groupId, { pageNumber: 1, pageSize: 100 });
    let data = response.data.data;
    const total = response.data.meta.totalItems ?? 0;
    const diff = total - data.length;
    if (diff > 0) {
      const chunkCount = Math.ceil(diff / 100);
      const requests = Array.from({ length: chunkCount }, (v: unknown, index) =>
        api.group.users(groupId, { pageNumber: index + 2, pageSize: 100 }),
      );
      const results = await Promise.all(requests);
      data = [...data, ...results.map((r) => r.data.data)].flat();
    }
    return data;
  };

  return {
    users,
    loading,
    searchUsers,
    fetchAllGroupMemebers,
  };
};
